import React, { useEffect } from 'react';
import SearchTopBarModal from './SearchTopBarModal';
import useScreenWidth from '../../../store/useScreenWidth';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useState } from 'react';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../store/useLanguageStore';

const SearchBtn = () => {

    const [searchModal, setSearchModal] = useState<boolean>(false);
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const isSmallScreen = useScreenWidth();

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.ctrlKey && event.key === '/') {
                event.preventDefault();
                setSearchModal(true);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return <React.Fragment>
        <div
            className='d-flex flex-row gap-2 align-items-center'
            role='button'
            title={language['Search'] + '...'}
            onClick={() => setSearchModal(true)}
        >
            <span className='button-hover-circle d-flex align-items-center justify-content-center button-sidebar-top'>
                <SearchOutlinedIcon className='icon-sidebar-top-color' sx={{ width: '22px', height: '22px', color: darkMode ? 'white' : '#4D5F71' }} />
            </span>

            {
                !isSmallScreen
                && <p
                    className='paragraph-text-muted'
                    style={darkMode ? { color: 'white' } : {}}
                >
                    {language['Search']} (Ctrl+/)
                </p>
            }
        </div>
        {
            searchModal
            && <SearchTopBarModal
                open={searchModal}
                setOpen={setSearchModal}
            />
        }
    </React.Fragment>
}

export default SearchBtn;